<template>
  <div>
    <el-form ref="form" :model="form" :rules="rules" label-width="140px" label-position="right">
      <el-form-item label="总净重差值(%)" :prop="type != 'preview' ? 'minFairValue' : ''">
        <div class="remarkNoLineH">
          <el-input v-model="form.minFairValue" type="number" placeholder="最低"></el-input>~
          <el-input
            v-model="form.maxFairValue"
            type="number"
            :min="form.minFairValue"
            placeholder="最高"
          ></el-input>
          <span class="red">注:设置果园过磅总净重的差值百分比</span>
        </div>
      </el-form-item>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="备注" class="remarkNoLineH">
            <el-input
              v-model="form.remark"
              placeholder="请输入"
              maxlength="300"
              type="textarea"
              resize="none"
              rows="3"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-row :gutter="20">
      <el-col :span="12">
        <div class="flex_end">
          <el-button class="batch-button" @click="cancel">取 消</el-button>
          <el-button class="line-button" @click="submitFrom">确 定</el-button>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { selectByName, editFairValue } from '@/api/system/reasonable'
export default {
  components: {},
  data() {
    return {
      form: { maxFairValue: '', minFairValue: '', rember: '', name: '验收差值' },
      rules: {
        minFairValue: [{ required: true, message: '请输人', trigger: 'change' }],
      },
    }
  },
  created() {
    this.selectByName()
  },
  methods: {
    cancel() {
      this.selectByName()
    },
    submitFrom() {
      if (Number(this.form.maxFairValue) < Number(this.form.minFairValue)) {
        this.$message.error('最大值不能比最小值小')
        return
      } else {
        editFairValue(this.form)
          .then((res) => {
            if (res.flag) {
              this.selectByName()
              this.$message.success('操作成功')
            } else {
              this.$message.error(res.message)
            }
          })
          .catch((error) => {
            console.log(error)
          })
      }
    },
    selectByName() {
      selectByName({ name: '验收差值' })
        .then((res) => {
          if (res.flag) {
            if (!res.data) {
              return
            } else {
              this.form = res.data
            }
          } else {
            this.$message.error(res.message)
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
  },
}
</script>
<style scoped lang='less'>
@import '~@/assets/tableList.less';
::v-deep {
  input[type='number'] {
    -moz-appearance: textfield; /* Firefox */
    appearance: textfield;
  }

  input[type='number']::-webkit-inner-spin-button,
  input[type='number']::-webkit-outer-spin-button {
    -webkit-appearance: none; /* Safari */
    margin: 0;
  }
  .remarkNoLineH {
    .el-input {
      width: 175px;
    }
  }
  .no-contract-type {
    padding: 30px;
    background-color: #f8f8f8;
    border-radius: 12px;
    text-align: center;
    border: 1px solid #dde4ff;
    margin-bottom: 20px;
  }
  .line-button {
    background-color: #c59429;
    color: #ffffff;
    border-color: #c59429;

    margin-left: 20px;
  }
}
.red {
  color: red;
  margin-left: 10px;
}
.flex_end {
  display: flex;
  justify-content: flex-end;
}
</style>